// import { getBuyerJWTToken } from '@common/utils/token';
import Review from '@common/models/Review';
import { fetchNextPageProductReviewsRequest } from '@common/store/productDetails/slice';
import { LoaderIcon } from '@instamojo/icons';
// import { getBuyerJWTToken } from '@common/utils/token';
// import Link from '@lib/Link';
// import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

// import { ReactComponent as StarIcon } from '@common/icons/Star.svg';
// import Ratingbar from './Ratingbar';
// import StarRating from './StarRating';
import ReviewComponent from './Review';

// import Carousel from '@brainhubeu/react-carousel';

export interface RatingProps {
  reviews: Array<Review>;
  nextReviewsUrl: string | null;
  reviewsCount: number;
  fetchNextPageProductReviewsRequest: typeof fetchNextPageProductReviewsRequest;
  isNextReviewsLoadingFailed: boolean;
  isNextReviewsLoading: boolean;
  productSlug: string;
}

const Rating: React.FunctionComponent<RatingProps> = ({
  reviews = [],
  fetchNextPageProductReviewsRequest,
  nextReviewsUrl,
  reviewsCount,
  isNextReviewsLoadingFailed,
  isNextReviewsLoading,
  productSlug,
}) => {
  return (
    <div id="Review" className={'bg-white flex flex-wrap rounded-md'} color-customisation="page-bg">
      <div className="flex w-full justify-between">
        <div className="w-full mb-20 md:mb-38">
          {reviewsCount && (
            <>
              {reviews.map((review, index) => (
                <div
                  key={index}
                  className="even:bg-reviewBG even:bg-opacity-09 md:pl-64 md:pr-56 py-20 md:py-36 px-16 md:px-0"
                >
                  <ReviewComponent
                    key={review.id}
                    name={review.customerName}
                    date={review.created}
                    review={review.review}
                    rating={review.rating}
                  />
                </div>
              ))}
              {isNextReviewsLoading && !isNextReviewsLoadingFailed && (
                <div className="flex justify-center pt-28 md:pr-60 md:mr-60 md:justify-end">
                  <LoaderIcon size={35} />
                </div>
              )}
              {nextReviewsUrl && (
                <div className="md:flex md:justify-end flex justify-center align-center md:mr-30">
                  <button
                    type="submit"
                    className="md:w-220 w-160 bg-reviewBG bg-opacity-09 font-medium mt-28 md:mt-28 md:h-48 uppercase h-38 text-12 md:text-18 focus:outline-none flex justify-center items-center"
                    button-customisation="page-button"
                    onClick={() => {
                      fetchNextPageProductReviewsRequest({
                        nextReviewsUrlPageNo: nextReviewsUrl,
                        productSlug: productSlug,
                      });
                    }}
                  >
                    View More Reviews
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(null, { fetchNextPageProductReviewsRequest })(Rating);
